/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreatePartnerVideoDtoGen,
  MrfiktivExceptionViewmodelGen,
  MrfiktivPageViewModelGen,
  MrfiktivPartnerVideoControllerGetOneWithAccessSignatureParamsGen,
  MrfiktivPartnerVideoControllerGetParamsGen,
  MrfiktivTranscriptViewModelGen,
  MrfiktivUpdatePartnerVideoDtoGen,
  MrfiktivVideoViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Video<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Video
   * @name PartnerVideoControllerCreate
   * @summary Create a video object
   * @request POST:/partner/{partnerId}/video
   * @secure
   * @response `201` `MrfiktivVideoViewModelGen` The video object
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerVideoControllerCreate = (
    partnerId: string,
    data: MrfiktivCreatePartnerVideoDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVideoViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/video`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Video
   * @name PartnerVideoControllerGet
   * @summary (Video - READ) Get all videos
   * @request GET:/partner/{partnerId}/video
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivVideoViewModelGen)[] })`
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerVideoControllerGet = (
    { partnerId, ...query }: MrfiktivPartnerVideoControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivVideoViewModelGen[] }, MrfiktivExceptionViewmodelGen>(
      {
        path: `/partner/${partnerId}/video`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }
    );
  /**
   * No description
   *
   * @tags Video
   * @name PartnerVideoControllerGetOne
   * @summary (Video - READ) Get a video
   * @request GET:/partner/{partnerId}/video/{videoId}
   * @secure
   * @response `200` `MrfiktivVideoViewModelGen` The video
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerVideoControllerGetOne = (partnerId: string, videoId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivVideoViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/video/${videoId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Video
   * @name PartnerVideoControllerDeleteOne
   * @summary (Video - DELETE) Delete a video
   * @request DELETE:/partner/{partnerId}/video/{videoId}
   * @secure
   * @response `200` `MrfiktivVideoViewModelGen` The video
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerVideoControllerDeleteOne = (partnerId: string, videoId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivVideoViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/video/${videoId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Video
   * @name PartnerVideoControllerUpdateMetadata
   * @summary (Video - UPDATE) Update video metadata after upload
   * @request PATCH:/partner/{partnerId}/video/{videoId}
   * @secure
   * @response `200` `MrfiktivVideoViewModelGen` Updated video
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerVideoControllerUpdateMetadata = (
    partnerId: string,
    videoId: string,
    data: MrfiktivUpdatePartnerVideoDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVideoViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/video/${videoId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Video
   * @name PartnerVideoControllerGetOneWithAccessSignature
   * @summary (Video - READ) Get a video
   * @request GET:/partner/{partnerId}/video/{videoId}/access
   * @secure
   * @response `200` `MrfiktivVideoViewModelGen` The video
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerVideoControllerGetOneWithAccessSignature = (
    { partnerId, videoId, ...query }: MrfiktivPartnerVideoControllerGetOneWithAccessSignatureParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivVideoViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/video/${videoId}/access`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Video
   * @name PartnerVideoControllerCancel
   * @summary (Video - UPDATE) Cancel a video upload
   * @request PUT:/partner/{partnerId}/video/{videoId}/cancel
   * @secure
   * @response `200` `MrfiktivVideoViewModelGen` The video
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerVideoControllerCancel = (partnerId: string, videoId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivVideoViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/video/${videoId}/cancel`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Video
   * @name PartnerVideoControllerGetTranscript
   * @summary (Video - READ) Get the auto-generated transcript for a video
   * @request GET:/partner/{partnerId}/video/{videoId}/transcript
   * @secure
   * @response `200` `MrfiktivTranscriptViewModelGen` The transcript for the video
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  partnerVideoControllerGetTranscript = (partnerId: string, videoId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivTranscriptViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/video/${videoId}/transcript`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
